module.exports = __webpack_public_path__ + "static/media/work-7.f9e70859.png";